import {
    GETWITHDRWALCOUNT_SUCCESS,
    GETWITHDRWALCOUNT_FAILED,
    RESET_GETWITHDRWALCOUNT,
    LOADING_GETWITHDRWALCOUNT,
    NETWORK_ERROR_GETWITHDRWALCOUNT,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetWithdrawalcount = () => {
    return { type: RESET_GETWITHDRWALCOUNT };
};

const getWithdrawalcount = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETWITHDRWALCOUNT });
    await partnerServices
        .post("getWithDrawalCount", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getWithdrawalcountsuccess(res.data));
                    break;
                default:
                    dispatch(getWithdrawalcountFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETWITHDRWALCOUNT, payload: err });
        });
};
function getWithdrawalcountsuccess(data) {
    return {
        type: GETWITHDRWALCOUNT_SUCCESS,
        payload: data,
    };
}
function getWithdrawalcountFailed(data) {
    return {
        type: GETWITHDRWALCOUNT_FAILED,
        payload: data,
    };
}

export { resetGetWithdrawalcount, getWithdrawalcount };
